import request from "@/plugins/axios/request";
/*
//定义接口
export function fetchList(query) {
  return request({
    url: '/article/list',
    method: 'get',
    params: query
  })
}

//使用接口
导入   import { fetchList } from '@/api/article'

使用
fetchList(this.listQuery).then(response => {
    this.list = response.data.items
    this.listLoading = false
}).catch(err => {

})
 */

export function login(ruleForm) {
    return request({
        url: "front/login",
        method: "post",
        data: ruleForm
    });
}

export function getInfo(token) {
    return request({
        url: "/user/info",
        method: "get",
        params: { token }
    });
}

export function logout() {
    return request({
        url: "/front/logout",
        method: "get"
    });
}
export function list() {
    return request({
        url: "page/api/category/1",
        method: "get"
    });
}
//获取登陆链接地址
export function getLoginUrl() {
    return request({
        url: "/front/getloginurl",
        method: "get"
    });
}
//获取用户信息
export function getUserInfo() {
    return request({
        url: "/front/getloginuser",
        method: "get"
    });
}
//获取用户信息
export function getUser() {
    return request({
        url: "code/redirect?curPath=/auth/queryUser",
        method: "get"
    });
}
export function getUsers() {
    return request({
        url: "/auth/queryUser?v=" + new Date().getTime(),
        method: "get"
    });
}
export function logOutUsers() {
    return request({
        url: "/login/loginOut/success",
        method: "get"
    });
}
export function queryUserById(params) {
    return request({
        url: "/channelCustomer/userInfo/queryUserById",
        method: "post",
        data: params
    });
}
export function modifyUserPwd(params) {
    return request({
        url: "/channelCustomer/userInfo/modifyUserPwd",
        method: "post",
        data: params
    });
}
export function loginOut2(params) {
    return request({
        url: "/login/loginOut2",
        method: "get",
        data: params
    });
}
export function loginOut3(params) {
    return request({
        url: "/login/loginOut/success",
        method: "get",
        data: params
    });
}
export function loginOut1(params) {
    return request({
        url: "/login/loginOut1",
        method: "get",
        data: params
    });
}
//验证旧手机号 验证是否是原手机号
export function checkOldPhone(params) {
    return request({
        url: "/channelCustomer/userInfo/checkOldPhone",
        method: "post",
        data: params
    });
}
//验证新手机号 修改用户手机号 (根据主键ID修改手机号码)
export function modifyUserPhone(params) {
    return request({
        url: "/channelCustomer/userInfo/modifyUserPhone",
        method: "post",
        data: params
    });
}
//发送验证码信息 发送手机短信验证码
export function sendPhoneSmsCode(params) {
    return request({
        url: "/channelCustomer/userInfo/sendPhoneSmsCode",
        method: "post",
        data: params
    });
}
//校验验证码是否正确 验证手机短信验证码是否一致
export function checkSmsCode(params) {
    return request({
        url: "/channelCustomer/userInfo/checkSmsCode",
        method: "post",
        data: params
    });
}
//验证手机号是否有没有绑定关系channelCustomer/userInfo/checkPhoneNumber
export const verificationphone = data =>
    request({
        url: "/channelCustomer/userInfo/checkPhoneNumber",
        method: "post",
        data: data
    });
//修改保存邮箱信息
export const updateEmail = data =>
    request({
        url: "/channelCustomer/userInfo/updateEmail",
        method: "post",
        data: data
    });
export const queryUser = data =>
    request({ url: "/auth/queryUser", method: "get", data });
